import $ from 'jquery';
import Modal from 'bootstrap/js/src/modal';

// TODO: refactor. This is only for test purpose. Make it with angularJS

const stepAddress = {
    modalAddress: $('#modal-addressbook'),
    buildModal() {
        new Modal(this.modalAddress[0], {
            show: false
        });
    },
    bindEvents() {
        // TODO: Refactor. this is a ugly part from accelerator

        $(document).on('click', '.js-address-book', (e) => {
            e.preventDefault();
            this.modalAddress.modal('show');
        });

        $(document).on('click', '.js-billing-address-edit', (e) => {
            e.preventDefault();
            $('#billing-address-form').submit();
        });

        $(document).on('click', '.js-new-address', (e) => {
            e.preventDefault();
            this.modalAddress.modal('hide');
            $('.js-add-address-show').show();
            $('.js-add-address-hide').hide();
        });

        $(document).on('change', '.js-delivery-same-billing', function () {
            if (this.checked) {
                $('.js-delivery-not-as-billing').addClass('c-address--disabled');
                $('.js-delivery-as-billing').removeClass('c-address--disabled');

                $('#selected-address').val($('#selected-address').data('payment-address'));
            } else {
                $('.js-delivery-not-as-billing').removeClass('c-address--disabled');
                $('.js-delivery-as-billing').addClass('c-address--disabled');

                $('#selected-address').val($('#selected-address').data('delivery-address'));
            }
        });
    }
};

// DOM ready
$(() => {
    if ($('#checkout-address-page').length) {
        stepAddress.buildModal();
        stepAddress.bindEvents();
    }
});

export default stepAddress;
